<template>
  <div class="mall-top-manage">
    <second-menu-link-content>
      <template v-slot:header>
        <span>顶部导航</span>
      </template>
      <template v-slot:content>
        <div class="btn-desc-container">
          <el-button class="btn-blue" @click="addTop">新增栏目</el-button>
          <span class="desc">最多可设置10个导航栏，可拖拽排序</span>
        </div>
        <div class="table bars">
          <el-table class="table-container" :data="columnList" row-key="id" align="center">
            <el-table-column label="栏目名称" prop="name"></el-table-column>
            <el-table-column label="栏目路径" prop="path"></el-table-column>
            <el-table-column label="是否显示">
              <template slot-scope="props">
                <el-switch @change="updateColumnStatus(props.row)" v-model="props.row.status"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="props">
                <div
                  v-if="operationList.findIndex(
                      (item) => item === operationsBtns.roleTopWriteFirst
                    ) !== -1 && 
                    props.$index === 0 &&
                    operationList.findIndex(
                      (item) => item === operationsBtns.roleTopWrite
                    ) !== -1
                    "
                >
                  <span class="column-btn" @click="toEdit(props)">编辑</span>
                  <span class="column-btn" @click="toDelete(props)">删除</span>
                </div>
                <div
                  v-if="operationList.findIndex(
                      (item) => item === operationsBtns.roleTopWriteAll
                    ) !== -1 && 
                    operationList.findIndex(
                      (item) => item === operationsBtns.roleTopWrite
                    ) !== -1
                  "
                >
                  <span class="column-btn" @click="toEdit(props)">编辑</span>
                  <span class="column-btn" @click="toDelete(props)">删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import Sortable from "sortablejs";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBMall from "models/db/mall.js";
const dbMall = new DBMall();
import {
  getDBOperationPermission,
} from "common/js/storage"; // 权限数据接口
export default {
  data() {
    return {
      // 权限列表数据
      operationList: [],
      operationsBtns: {
        // 顶部导航栏删改拖
        roleTopWrite: "ROLE_TOP_WRITE",
        // 顶部导航栏删改拖(单个页面)
        roleTopWriteFirst: "ROLE_TOP_WRITE_FIRST",
        // 顶部导航栏删改拖(所有页面)
        roleTopWriteAll: "ROLE_TOP_WRITE_ALL",
      },
      columnList: [],
    };
  },
  methods: {
    updateColumnStatus(column) {
      let { id, name, path, status, inVisitor } = column;
      let data = {
        id,
        name,
        path,
        inVisitor: Number(inVisitor),
        status: Number(status)
      };
      this._updateColumn(data);
    },
    addTop() {
      if (this.columnList.length < 10) {
        this.$router.push({
          path: "/admin/mall/mall-top/add-mall-top",
        });
      } else {
        this.$message.error("最多可设置10个导航栏");
      }
    },
    toEdit(props) {
      let id = Number(props.row.id);
      this.$router.push({
        path: "/admin/mall/mall-top/add-mall-top",
        query: {
          id: id
        }
      });
    },
    toDelete(props) {
      this.$confirm("即将删除该栏目", "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 删除某个栏目
          let index = props.$index;
          let id = Number(props.row.id);
          // 服务器删除
          this._deleteColumnById(id);
          // 本地数据更新
          this.columnList.splice(index, 1);
        })
        .catch(action => {
          if (action === "cancel") {
            console.log("取消删除操作");
          }
        });
    },
    // 利用Sortable.js实现行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.columnList.splice(oldIndex, 1)[0];
          _this.columnList.splice(newIndex, 0, currRow);
          let data = [];
          _this.columnList.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.weight = index;
            data.push(obj);
          });
          dbMall.getDBMallTopSort(data).then(res => {
            if (res.success) {
              console.log("修改成功");
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    _successUpdateColumnTip() {
      this.$message({
        message: "更新专栏成功",
        center: true,
        type: "success",
        duration: 1000
      });
    },
    _failUpdateColumnTip() {
      this.$message({
        message: "更新专栏失败，请重试",
        center: true,
        type: "success",
        duration: 1000
      });
    },
    // 获取所有栏目
    _getColumnList() {
      dbMall
        .getColumnList()
        .then(res => {
          console.log("栏目--", res.result);
          res.result.map(item => {
            this.columnList.push({
              id: item.id,
              name: item.name,
              path: item.path,
              inVisitor: item.inVisitor,
              status: Boolean(item.status)
            });
          });
        })
        .catch(e => {
          console.log("异常--", e);
        });
    },
    // 更新栏目
    _updateColumn(data) {
      dbMall
        .updateColumn(data)
        .then(res => {
          if (res.success) {
            // 更新专栏成功
            this._successUpdateColumnTip();
          } else {
            // 更新专栏失败
            this._failUpdateColumnTip();
          }
        })
        .catch(e => {
          // 更新专栏失败
          this._failUpdateColumnTip();
        });
    },
    _deleteColumnById(id) {
      dbMall
        .deleteColumnById(id)
        .then(res => {
          console.log("删除--", res);
          if (res.success) {
            console.log("删除成功--");
          }
        })
        .catch(e => {
          console.log("异常--", e);
        });
    }
  },
  created() {
    this.operationList = getDBOperationPermission();
    setTimeout(() => {
      this._getColumnList();
    },400)
  },
  mounted() {
    if (
      this.operationList.findIndex((item) => item === this.operationsBtns.roleTopWrite) !== -1 && 
      this.operationList.findIndex((item) => item === this.operationsBtns.roleTopWriteAll) !== -1 
    ) {
      this.rowDrop();
    }
  },
  components: {
    SecondMenuLinkContent
  }
};
</script>

<style lang="scss" scoped>
.mall-top-manage {
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(96, 98, 102, 1);
  .btn-desc-container {
    display: flex;
    margin-bottom: 16px;
    .desc {
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      font-size: 12px;
      color: rgba(144, 147, 153, 1);
      padding-bottom: 4px;
    }
  }
  .bars {
    .table-container {
      .column-btn {
        font-size: 12px;
        font-family: "PingFangSC-Regular";
        font-weight: 400;
        color: rgba(61, 116, 242, 1);
        cursor: pointer;
        margin-right: 16px;
      }
    }
  }
}
</style>
